<template>
  <div id="background" style="height: 100%;
    width: 100%;
    position:fixed;
    background: url(/static/images/monton.png) no-repeat center center;
    background-attachment: fixed;
    background-size: cover;
    height: 100%;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;">



    <div id="main_container" style="height: 100%;width: 100%;">



<!--防伪&商品信息开始  -->
         <div  v-if="showAntiPopup"> 
            
            <div   style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 99;;width: 100%;height: 50px;opacity: 1;">
                        <div  style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p style="background: url(/static/images/barcode.png);background-size: cover;width: 30px;height: 30px;"></p>
                        </div>
            </div>
            <div class="modal-anti" >
                        <div style="margin-top: 14%;display: flex;flex-direction: column;text-align: left;">
                            <div>
                                <span style="color: white;font-size: 1rem;">产品名称&nbsp;&nbsp;</span>
                                <span style="color: white;font-size: 1rem;" v-text="productName"></span>
                            </div>
                            <div style="margin-top: 20px;">
                                <span style="color: white;font-size: 1rem;">产品型号&nbsp;&nbsp;</span>
                                <span style="color: white;font-size: 1rem;" v-text="productNo"></span>
                            </div>
                            <p style="color: white;font-size: 0.8rem;;margin-top: 14px;text-align: center;" v-html="antiresult"></p>
                            
                            <div v-if="showActivity"  style="width: 100%;height: fit-content;display: flex;justify-content: center;align-items: center;">
                            <div  :disabled="isDisabled" style="z-index: 11;;width: 200px;height: 35px;margin-top: 25px;background-color:rgb(56, 28, 40); border-radius: 20px;display: flex;align-items: center;" @click="joinActivity">
                                <span style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;">领取积分</span>
                            </div>
                           </div>

                        </div> 
            </div>
        </div>  
       <!-- 防伪&商品信息结束 -->


      
       <!--中奖成功弹框开始-->
       <div v-if="showSuccessTip"> 
            <div   style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 88;;width: 100%;height: 50px;opacity: 1;">
                        <div  style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p style="background: url(/static/images/star.png);background-size: cover;width: 33px;height: 30px;"></p>
                        </div>
            </div>
            <div class="modal-anti" >
                        <div style="margin-top: 14%;margin-left: 5%;display: flex;flex-direction: column;text-align: left;">
                            
                            <p style="color: white;font-size: 1.2rem;margin-top: 14px;text-align: center;" v-html="getScoreTip"></p>
                            <p style="color: white;margin-top: 14px;text-align: center;">
                               <span style="font-size: 2.2rem;color:rgb(217, 94, 76);font-weight: bold;" v-html="getScore"></span>
                               <span style="font-size: 1.2rem;">积分</span>
                            </p>
                                <wx-open-launch-weapp
                                        id="launch-btn"
                                        :appid="miniAppId"
                                        :username="miniAppOriginalId" 
                                        :path="miniAppPage">
                                        <script type="text/wxtag-template">
                                        <input type="button" value="前往商城" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            margin-left: 7%;
                                                            margin-top: 25px;background-color:rgb(56, 28, 40);
                                                            width: 200px;height: 35px;"/>
                                    </script>
                                </wx-open-launch-weapp>
                        </div> 
             </div>
        </div>
       <!-- 中奖成功弹框结束 -->




       <!--中奖错误弹框开始  -->
        <div  v-if="showErrorTip"> 
            <div   style="position: absolute;display: flex;justify-content: center;
                        margin: -6% 0%; /* 上下自动，左右15% */
                        border: 0px solid;
                        text-align: center;z-index: 88;;width: 100%;height: 50px;opacity: 1;">
                        <div  style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                        <p style="background: url(/static/images/star.png);background-size: cover;width: 33px;height: 30px;"></p>
                        </div>
            </div>
            <div class="modal-anti" >
                        <div style="margin-top: 14%;display: flex;flex-direction: column;text-align: left;">
                            
                            <p style="color: white;font-size: 1.2rem;;margin-top: 10px;text-align: center;" v-html="errorTip"></p>
                            <!-- <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">抱歉</p> 
                            <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">此码已参与积分</p>
                            <p style="color: white;font-size: 1.2rem;;margin-top: 14px;text-align: center;">感谢您的支持</p> -->
                                <!-- <span style="width: 100%;;text-align: center;font-size: 1rem;color: #FFFFFF;">前往商城</span> -->
                                <wx-open-launch-weapp
                                        id="launch-btn"
                                        :appid="miniAppId"
                                        :username="miniAppOriginalId" 
                                        :path="miniAppPage">
                                        <script type="text/wxtag-template">
                                        <input type="button" value="前往商城" style="border: none;
                                                            z-index: 0;
                                                            color: white;
                                                            padding: 8px 30px;
                                                            text-align: center;
                                                            text-decoration: none;
                                                            display: block;
                                                            font-size: 14px;
                                                            border-radius: 20px;
                                                            margin-left: 7%;
                                                            margin-top: 25px;background-color:rgb(56, 28, 40);
                                                            width: 200px;height: 35px;"/>
                                    </script>
                                </wx-open-launch-weapp>
                        </div> 
             </div>
        </div>
       <!-- 中奖错误弹框结束 -->
        

        <!--活动规则开始-->
        <div v-if="showPopup"> 
            <div id="activityRule" class="modal"  @click="closePopup()"></div> 
            <div   style="position: absolute;display: flex;justify-content: center;
                margin: -6% 0%; /* 上下自动，左右15% */
                border: 0px solid;
                text-align: center;z-index: 99;;width: 100%;height: 50px;opacity: 1;">
                <div  style="border: 0px solid;z-index: 99;;width: 50px;height: 50px; background-color: white;border-radius: 50%;opacity: 1;display: flex;align-items: center;justify-content: center;">
                <p style="background: url(/static/images/info-circle-o.png);background-size: cover;width: 35px;height: 35px;"></p>
                </div>
            </div>

            <div class="modal-content" >
                    <!-- <span class="close" @click="closePopup()">&times;</span> -->
                    <p v-html="activityRule" style="margin-top:15px;color: white;"></p>
            </div>
            
        </div>
       <!--活动规则结束-->
       

        <div id="bottom_bar" style="position: absolute;bottom: 2rem;text-align: center;height: 20px;width: 100%;">
            <span style="text-align: center;color:#ffffff;" @click="openPopup">规则说明</span>
        </div>
<!-- 
        <div style="margin-top: 30%;margin-left: 5%;display: flex;flex-direction: column;">
           <span style="color: #F4ED2F;font-size: 1.7rem;margin-top: 3px;">防伪信息</span>
           <span style="color: #FFFFFF;font-size: 1.2rem;;margin-top: 3px;" v-html="antiresult"></span>
        </div>



        <div style="margin-top: 14%;margin-left: 5%;display: flex;flex-direction: column;">
           <span style="color: #F4ED2F;font-size: 1.7rem;margin-top: 3px;">商品信息</span>
           <div>
            <span style="color: #FFFFFF;font-size: 1.2rem;;margin-top: 3px;">商品名称&nbsp;&nbsp;</span>
            <span style="color: #FFFFFF;font-size: 1.2rem;;margin-top: 3px;" v-text="productName"></span>
           </div>
           <div>
            <span style="color: #FFFFFF;font-size: 1.2rem;;margin-top: 3px;">商品编号&nbsp;&nbsp;</span>
            <span style="color: #FFFFFF;font-size: 1.2rem;;margin-top: 3px;" v-text="productNo"></span>
           </div>
        </div> 



        <div style="margin-top: 10%;margin-left: 5%;display: flex;justify-content: space-between;align-items:center;">
           <span style="color: #F4ED2F;font-size: 1.7rem;margin-top: 3px;">其他拓展</span>
           <span style="color: #FFFFFF;font-size: 1.1rem;margin-top: 3px;margin-right: 1rem;text-decoration: underline;" @click="openPopup">规则说明</span>
        </div>-->
  
<!-- 
        <div v-if="showActivity" style="background-color: rgba(255, 255, 255, 0.7);border-radius: 10px;margin-top: 10%;margin-left: 5%;margin-right: 5%;display: flex;justify-content: space-between;align-items:center;height: 7rem;">
           <span style="color: #F4ED2F;font-size: 1.8rem;margin-top: 1rem;margin-left: 2.3rem;font-weight: bold;margin-bottom: 1rem;">领取积分</br>参与活动</span>
           <div :disabled="isDisabled" style="width: 80px;height: 80px;background-color: #F4ED2F;  border-radius: 50%; margin-right: 1rem;display: flex;align-items: center;" @click="joinActivity">
             <span style="width: 100%;;text-align: center;font-size: 1.6rem;color: #FFFFFF;font-weight: bold;">点击</span>
           </div>
        </div>
    </div>

     -->
<!-- 
     <div id="successTip" class="modal"  v-if="showSuccessTip">
        <div class="modal-win">
           <span class="close" @click="closeSuccessTip()">&times;</span>
           <p style="text-align: center;color: #F4ED2F;font-size: 1.5rem;font-size: 20px;font-weight: bold;" v-html="getScoreTip"></p>
           <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div style="display: flex;align-items: center;justify-content: center;">
                <img src="/static/images/score.png" width="45px" height="45px" />
                <span style="font-size: 15px;font-weight: bold;" v-html="getScore"></span>
           </div>
           </div>
           <p>

            <wx-open-launch-weapp
                id="launch-btn"
                :appid="miniAppId"
                :username="miniAppOriginalId" 
                :path="miniAppPage">
                <script type="text/wxtag-template">
            <input type="button" value="前往商城" style="background-color: #F4ED2F; 
                                    border: none;
                                    color: white;
                                    padding: 8px 30px;
                                    text-align: center;
                                    text-decoration: none;
                                    display: inline-block;
                                    font-size: 14px;
                                    font-weight: bold;
                                    border-radius: 10px;"/>
            </script>
            </wx-open-launch-weapp>
        </p>
        </div>
    </div>

    <div id="errorTip" class="modal" v-if="showErrorTip">
        <div class="modal-win">
            <span class="close" @click="closeErrorTip()">&times;</span>
            <p style="text-align: center;color: #F4ED2F;margin-top: 40px;font-size: 1.5rem;font-size: 20px;font-weight: bold;" v-html="repeatJoinTip"></p>
            <p>
        <wx-open-launch-weapp
        id="launch-btn"
        :appid="miniAppId"
        :username="miniAppOriginalId" 
        :path="miniAppPage">
        <script type="text/wxtag-template">
            <input type="button" value="前往商城" style="background-color: #F4ED2F; 
                                    border: none;
                                    color: white;
                                    padding: 8px 30px;
                                    text-align: center;
                                    text-decoration: none;
                                    display: inline-block;
                                    font-size: 14px;
                                    font-weight: bold;
                                    border-radius: 10px;"/>

             </script>
            </wx-open-launch-weapp>
        </p>
        </div> -->
    </div>
  </div>
</template>


<style scoped>
/* 背景遮罩 */
.modal {
  position: fixed; /* 固定位置 */
  z-index: 0; /* 位于顶层 */
  left: 0;
  top: 0;
  width: 100%; /* 宽度全屏 */
  height: 100%; /* 高度全屏 */
  overflow: auto; /* 超出内容可滚动 */
}
 
/* 模态内容 */
.modal-content {
  overflow: auto;
  background-color: #fefefe;
  margin: 50% auto; /* 上下自动，左右15% */
  padding: 25px;
  border: 1px solid rgb(56, 28, 40);
  width: 75%;
  height: 300px;
  text-align: center;
  background-color: rgba(254, 251, 251, 0.2); 
  z-index:12;
  border-radius: 20px;
}

/* 模态内容 */
.modal-anti {
  overflow: auto;
  background-color: #fefefe;
  margin: 50% auto; /* 上下自动，左右15% */
  padding: 25px;
  border: 1px solid rgb(56, 28, 40);
  width: 75%;
  height: 270px;
  text-align: center;
  background-color: rgba(254, 251, 251, 0.2); 
  z-index:12;
  border-radius: 20px;
}
 
</style>
<script>
import { getAntiResult,getJSSDK, getWechatAuth,joinActivity,getInfoByCode,getTemplate,getScoreConfig,registerByOpenId } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
    data() {
        return {
            antiresult:"",
            productNo:null,
            productName:"",
            eno:"",
            deptId:0,
            code:"",
            showPopup:false,
            activityRule:"",
            activityId:"",
            authCode:"",
            userToken:"",
            showActivity:false,
            showSuccessTip:false,
            showErrorTip:false,
            isDisabled:false,
            getScoreTip:"",
            getScore:"",
            shopUrl:"",
            miniAppId:"",
            miniAppOriginalId:"",
            miniAppPage:"",
            showAntiPopup:true,
            antiQuery:false,
            errorTip:"抱歉<br/>此码已参与积分<br/>感谢您的支持"
        };
    },
    methods: {
        getAuth(){
            const url=window.location.href.split('#')[0];
            sessionStorage.setItem("wechatAuth",true);
            getWechatAuth(url,"wxbc22565b3e7a59fd",1).then(res => {
                const data = res.data;
                window.location.href=data;
            }).catch(err =>
                alert("获取微信授权失败"+err)
            )
        },
        async joinActivity(){
            this.isDisabled=true;
            if(this.authCode==undefined || this.authCode=="" || this.authCode==null)
            {
                this.getAuth()
                return;
            }
            await registerByOpenId(this.eno,this.authCode).then(res => {
               this.userToken=res.data.data.token;
            })


            const data={
                code:this.code,
                activityId:this.activityId,
                authCode:this.authCode,
                userToken:this.userToken
            }
            await joinActivity(data).then(res => {
               //alert(JSON.stringify(res));
               if(res.data.code=="200"){
                this.getScoreTip="恭喜您获得"+res.data.data.giftValue+"积分"
                  this.getScore=res.data.data.giftValue;
                  this.showSuccessTip=true;
                  this.showAntiPopup=false;
                  this.showPopup=false;
                  this.showErrorTip=false;

               }else if(res.data.code=="500001"){
                  this.errorTip="抱歉<br/>此码已参与积分<br/>感谢您的支持"
                  this.showAntiPopup=false;
                  this.showPopup=false;
                  this.showErrorTip=true;
                  this.showSuccessTip=false;
               }else{
                  this.errorTip=res.data.message
                  this.showAntiPopup=false;
                  this.showPopup=false;
                  this.showErrorTip=true;
                  this.showSuccessTip=false;
               }
            })
            this.isDisabled=false;
            sessionStorage.removeItem("wechatAuth");
        },
        async getCodeInfo() {
            this.code=this.$route.query.c
            this.authCode=this.$route.query.wyAuthCode
            await getInfoByCode(this.$route.query.c).then(res => {
                this.eno = res.data.data.code
                console.log(this.eno)
                this.deptId=res.data.data.deptId
                this.productNo = res.data.data.productNo
                this.productName = res.data.data.productName
                if(this.productNo!=null)
                {
                    this.showActivity=true;
                }
                
            })
        },
        async getTemplate() {
            await getTemplate(this.deptId).then(res => {
                this.activityId=res.data.data.activityId;
                this.activityRule=res.data.data.activityRule;
            })
        },
        async getScoreConfig() {
            getScoreConfig(this.deptId).then(res => {
               this.shopUrl=res.data.data.shopUrl
               const data=this.shopUrl.split('|')
               this.miniAppId=data[0]
               this.miniAppOriginalId=data[1]
               this.miniAppPage=data[2]
            })
        },
        openPopup(){
            this.showAntiPopup=false;
            this.showPopup=true;
            this.showErrorTip=false;
            this.showSuccessTip=false;
        },
        closePopup(){
            this.showPopup=false;
            this.showAntiPopup=true;
            this.showErrorTip=false;
            this.showSuccessTip=false;
        },
        async getResult() {
            const params = this.$route.query;
            const code = params.c;
            const antiQueryResult=sessionStorage.getItem("antiQueryResult");
            if(antiQueryResult!=null){
                this.antiresult = antiQueryResult
                return;
            }
            getAntiResult(code).then(res => {
                const data = res.data;
                if (data == null || data.code == "500") {
                    alert("防伪查询失败,请联系管理员");
                } else {
                    this.antiresult = data.message
                    this.antiQuery=true
                    sessionStorage.setItem("antiQueryResult",this.antiresult)
                }
            }).catch(err =>
                alert("查询异常，请联系管理员")
            )


            
        },
        async getConfig(){
            await this.getCodeInfo()
            await this.getScoreConfig()
            await this.getTemplate();
            const wechatAuth=sessionStorage.getItem("wechatAuth");
            if(wechatAuth=="true"){
              await this.joinActivity()
              return;
            }
        },
        getWxJs(){
            const url =encodeURIComponent(window.location.href.split('#')[0])
            getJSSDK(url,"wxbc22565b3e7a59fd").then(res => {
                console.log(res)
                const data=res.data.data
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名，见附录1
                    openTagList:["wx-open-launch-weapp","wx-open-launch-app"],
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'hideMenuItems',
                        'showMenuItems',
                        'hideAllNonBaseMenuItem',
                        'showAllNonBaseMenuItem',
                        'translateVoice',
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'chooseImage',
                        'previewImage',
                        'uploadImage',
                        'downloadImage',
                        'getNetworkType',
                        'openLocation',
                        'getLocation',
                        'hideOptionMenu',
                        'showOptionMenu',
                        'closeWindow',
                        'scanQRCode',
                        'chooseWXPay',
                        'openProductSpecificView',
                        'addCard',
                        'chooseCard',
                        'openCard'
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    wx.hideMenuItems({
                        menuList: [
                            'menuItem:copyUrl',
                            'menuItem:openWithQQBrowse',
                            'menuItem:openWithSafari',
                            'menuItem:email',
                            'menuItem:readMode',
                            'menuItem:originPage',
                            'menuItem:delete',
                            'menuItem:editTag'
                        ]
                        });
                });

            }).catch(err =>
                alert("获取微信授权失败"+err)
            )
        }
    },
    mounted:function(){
        this.getWxJs()
        this.getResult()
    },
    created:function(){
        this.getConfig();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MaiTeng/Index.vue